import React, { useState, useEffect } from "react";
import styles from "./input.module.scss";
import cx from "classnames";

export const SearchBar = ({ query, onSearch }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(query || "");
  }, [query]);

  const handleChange = (e) => {
    const text = e.target.value;
    setValue(text);
    if (text === "") {
      onSearch(null);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(value ? value.trim() : null);
  };

  const handleClear = () => {
    setValue("");
    onSearch(null);
  };

  return (
    <div className={cx(styles.searchBar)}>
      <i className={cx(styles.icon, "paperflite-search")}></i>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Type here to search..."
          value={value}
          onChange={handleChange}
        />
        {value && (
          <i
            className={cx(
              styles.icon,
              styles.clear,
              "fa-solid fa-circle-xmark",
            )}
            onClick={handleClear}
          ></i>
        )}
      </form>
    </div>
  )
};